import area from '@turf/area';

function compare(a, b) {
  if (a < b) return 1;
  if (b < a) return -1;
  return 0;
}

/**
 * Compares two region items by area (biggest to smallest)
 *   and then by id (for for deterministic sort if areas are the same)
 *
 * @param {object} a first region
 * @param {object} b second region
 */
export function compareByAreaAndId(a, b) {
  let areaA = area(a.geoJSON);
  let areaB = area(b.geoJSON);
  let r = compare(areaA, areaB);
  if (r === 0) return compare(a.id, b.id);
  return r;
}

export function compareByAreaAndIdInverse(a, b) {
  return -compareByAreaAndId(a, b);
}
